import { render, staticRenderFns } from "./SettingsNotificationIcon.vue?vue&type=template&id=5f4fcb4a&scoped=true&"
import script from "./SettingsNotificationIcon.vue?vue&type=script&lang=js&"
export * from "./SettingsNotificationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4fcb4a",
  null
  
)

export default component.exports